import React, { useState, useEffect } from "react";
import ProcessBar from "../components/layout/ProcessBar";
import PageNavigation from "../components/layout/PageNavigation";
import BasicInfoSection from "../components/sections/BasicInfoSection";
import PreHospitalSection from "../components/sections/PreHospitalSection";
import EMSTimeSection from "../components/sections/EMSTimeSection";
import EMSCPRSection from "../components/sections/EMSCPRSection";
import DateInput from "../components/fields/DateInput";
import DateTimeInput from "../components/fields/DateTimeInput";
// OHCAForm.js
import "../styles/variables.css";
import "../styles/form.css";
import "../styles/components.css";
import "../styles/typography.css";
import PatientArrivalSection from "../components/sections/PatientArrivalSection";
import UnderlyingDiseaseSection from "../components/sections/UnderlyingDiseaseSection";
import EmergencyRoomCPRSection from "../components/sections/EmergencyRoomCPRSection";
import EmergencyRoomResultSection from "../components/sections/EmergencyRoomResultSection";
import AdmissionSection from "../components/sections/AdmissionSection";
import DischargeSection from "../components/sections/DischargeSection";
import CPCSection from "../components/sections/CPCSection";
import { NSESection, PupilSection } from "../components/sections/page4Sections";

//메뉴바 추가하기
import MenuBar from "../components/common/MenuBar";
import { useParams, useNavigate } from "react-router-dom";

const API_ENDPOINT =
  "https://bap7u9i7ig.execute-api.ap-northeast-2.amazonaws.com/prod";

const OHCAEditForm = () => {
  const { id: caseId } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 4;
  const navigate = useNavigate();
  const FIXED_GROUP_ID = 5; // 고정된 group_id 값 추가
  const [debugInfo, setDebugInfo] = useState(null);
  const [isDebugVisible, setIsDebugVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // formData state 업데이트
  const [formData, setFormData] = useState({
    // 1-1. 기본정보
    pt_name: "", // 환자이름
    pt_number: "", // 환자번호
    birth: "", // 생년월일
    sex: "", // 성별
    height: "", // 키
    weight: "", // 몸무게
    waist_circumference: "", // 허리 둘레
    hip_circumference: "", // 엉덩이 둘레
    ED_arrival_time: "", // 응급실 도착시각
    transfer: "", // 타 병원에서 전원 옴
    transfer_hospital: "", // 전원 보낸 병원명
    pre_cpr: "", // 전원 전 심폐소생술 시행
    pre_defibrillation: "", // 전원 전 제세동 시행

    // 1-2. 병원 전 단계
    arrest_location: "", // 심정지 발생장소
    arrest_location_others: "", // 기타 장소 상세내용
    Baseline_CPC: "", // 심정지 발생 전 CPC
    witness: "", // 심정지 목격
    arrest_time: "", // 심정지 발견 시각
    LNT_time: "", // 마지막 생존 확인 시각
    witness_by: "", // 심정지 발견 목격자/발견자
    Immediate_CPR: "", // 즉시 흉부압박 시행여부
    Bystander_CPR: "", // 목격자/발견자 흉부압박
    Bystander_CPR_time: "", // 목격자/발견자 흉부압박 시각
    Bystander_AED: "", // 목격자/발견자 AED 사용

    // EMS 신고~현장 이탈 시각
    EMS_call_time: "", // EMS 신고 시각
    EMS_arrive_time: "", // EMS 현장 도착 시각
    X2nd_arrive_time: "", // 2번째 구급차 도착 시각
    EMS_Departure_time: "", // EMS 현장 이탈 시각

    // 구급대원 현장 심폐소생술
    EMS_CPR: "", // 구급대원 흉부압박
    EMS_CPR_time: "", // 구급대원 흉부압박 시각
    Mech_CPR: "", // Mechanical CPR device 적용
    EMS_1st_rhythm: "", // 첫 리듬
    EMS_1st_rhythm_time: "", // 첫 리듬 시각
    EMS_1st_rhythm_by: "", // 첫 리듬 관찰자
    EMS_shock: "", // 구급대원 제세동
    EMS_shock_time: "", // 구급대원 첫 제세동 시각
    EMS_shock_success: "", // 구급대원 제세동 성공 여부
    EMS_shock_energy: "", // 구급대원 첫 제세동 에너지
    EMS_shock_number: "", // 구급대원 제세동 횟수
    EMS_airway: "", // 구급대원 기관삽관
    advanced_airway_time: "", // 전문기도유지기 삽입 시각
    EMS_iv: "", // 구급대원 정맥로 확보
    EMS_fluid: "", // 응급실 내원 전 수액 투여
    EMS_epi: "", // 구급대원 에피네프린 투여
    EMS_epi_time: "", // 구급대원 에피네프린 투여 시각
    EMS_amio: "", // 구급대원 아미오다론 투여
    EMS_amio_time: "", // 구급대원 아미오다론 투여 시각
    Pre_ROSC: "", // 병원 도착 전 자발순환 회복
    Pre_ROSC_time: "", // 병원 도착 전 자발순환 회복 시각
    Pre_stop_CPR: "", // 병원 도착 전 심폐소생술 중단
    Pre_stop_CPR_cause: "", // 병원 도착 전 심폐소생술 중단 이유

    // 2-1. 응급실 처치
    defibrillation: "", // 제세동 시행
    first_defibrillation_time: "", // 최초 제세동 시각
    total_defibrillation_count: "", // 총 제세동 횟수
    rosc: "", // 자발순환회복
    first_rosc_time: "", // 최초 자발순환회복 시각

    // 3-1. 환자 도착 정보
    ED_arrival_time_two: "", // 응급실 도착 시각
    Transport: "", // 병원 이송 수단
    Resusci_room_time: "", // 소생실/중환구역 입실 시각

    // 3-2. 기저질환
    HTN: "", // 고혈압
    DM: "", // 당뇨
    dyslipidemia: "", // 고지혈증
    LC: "", // 간경화
    CHF: "", // 심부전
    stroke: "", // 뇌졸중
    PM: "", // Pacemaker
    ICD: "", // ICD
    CKD: "", // 신부전
    malig: "", // 암/혈액암

    // 3-3. 응급실 심폐소생
    ED_CPR: "", // 응급실 소생술 시도
    ED_CPR_cause: "", // 소생술 미시행 이유
    ED_CPR_datetime: "", // 응급실 흉부압박 시작 시각
    ED_rhythm: "", // 응급실에서 첫 리듬
    ED_defib: "", // 응급실 제세동시도
    ED_defib_datetime: "", // 응급실 첫 제세동 시각
    ED_intubation: "", // 응급실 기관내 삽관
    ED_intubation_datetime: "", // 응급실 기관내 삽관 시각
    ED_epi: "", // 응급실 에피네프린 투여
    ED_epi_datetime: "", // 응급실 에피네프린 투여 시각
    ED_amio: "", // 응급실 아미오다론 투여
    ED_amio_datetime: "", // 응급실 아미오다론 투여 시각
    ED_central: "", // CPR 중 C-line 삽입
    ED_CVC_insert_datetime: "", // CPR 중 C-line 삽입 시각
    ED_Aline: "", // CPR 중 A-line 삽입
    ED_Aline_insert_datetime: "", // CPR 중 A-line 삽입 시각
    NIRS: "", // NIRS
    REBOA: "", // REBOA
    ECPR: "", // ECPR
    pump_on_time: "", // Pump on time

    // 3-4. 응급실 심폐소생술 결과
    ED_stop_datetime: "", // 심폐소생술 중단 시각
    ED_fluid: "", // 심폐소생술 중 수액 투여량
    ED_stop_cause: "", // 심폐소생술 중단 이유
    Cause_arrest: "", // 심정지 원인
    ROSC: "", // ROSC 여부, 장소 관계 없음
    ED_ROSC: "", // ROSC, 응급실에서만
    ED_nonsust_ROSC_datetime: "", // Not sustained ROSC 시각
    ED_sust_ROSC_datetime: "", // Sustained ROSC 시각
    ED_ROSC_ECG: "", // ROSC 심전도
    ED_ROSC_ECG_others: "", // ROSC 심전도 기타
    ED_disposition: "", // 결과
    NCV_em: "", // NCV 응급용 선별검사
    admission_memo: "", // 초진 기록지
    discharge_memo: "", // 응급실 퇴실 기록지

    // ROSB 관련 필드 추가
    ROSB: "", // ROSB 여부
    ROSB_time: "", // ROSB 시각

    // 3-4. 응급실 심폐소생술 결과 - 추가 필드들

    // 심정지 원인 관련 추가 필드
    Cause_medical: "", // 심정지 비심인성 원인
    Cause_trauma: "", // 심정지 외상성 원인
    Cause_asphyxia: "", // 심정지 질식 원인

    // Re-arrest 관련 필드들
    ROSC1_Re_arrest: "", // 1st re-arrest 여부
    ROSC1_Re_arrest_datetime: "", // 1st re-arrest time
    "1st_rearrest_ROSC": "", // 1st re-arrest ROSC 상태
    "1st_rearrest_susROSC_datetime": "", // 1st re-arrest Sustained ROSC time

    ROSC2_Re_arrest: "", // 2nd re-arrest 여부
    ROSC2_Re_arrest_datetime: "", // 2nd re-arrest time
    "2nd_rearrest_ROSC": "", // 2nd re-arrest ROSC 상태
    "2nd_rearrest_susROSC_datetime": "", // 2nd re-arrest Sustained ROSC time

    ROSC3_Re_arrest: "", // 3rd re-arrest 여부
    ROSC3_Re_arrest_datetime: "", // 3rd re-arrest time
    "3rd_rearrest_ROSC": "", // 3rd re-arrest ROSC 상태
    "3rd_rearrest_susROSC_datetime": "", // 3rd re-arrest Sustained ROSC time

    // 결과 관련 추가 필드들
    Dead: "", // 사망 상세 정보
    Admission: "", // 입원 상세 정보
    NCV: "", // NCV 정규검사

    // ROSC ECG Others 필드
    ED_ROSC_ECG_others: "", // ROSC 심전도 Others 선택 시 상세 내용

    // 4-1. 입원 관련 필드
    DNR: "", // DNR 작성여부
    TTM: "", // TTM 시행
    TTM_temp: "", // TTM 초기 설정 온도
    TTM_reason: "", // TTM 미사유
    TTM_others_text_input: "", // TTM 미사유 기타 내용
    ECMO: "", // CPR 후 ECMO 시행
    CRRT: "", // CRRT 시행

    // 4-2. 퇴원 관련 필드
    Discharge_datetime: "", // 퇴원시각
    Discharge_Type: "", // 퇴원형태
    Discharge_Note: "", // 퇴원기록지

    // 4-3. CPC 관련 필드
    Discarge_CPC: "", // 퇴원시 CPC
    "1month_CPC": "", // 1개월 후 CPC
    "3month_CPC": "", // 3개월 후 CPC
    "6month_CPC": "", // 6개월 후 CPC
    "12month_CPC": "", // 12개월 후 CPC

    // 의료 이미지 관련 필드
    chest_image: "", // Chest X-ray 종류
    file_chest: null, // Chest X-ray 파일
    file_EKG: null, // EKG 파일

    // NSE 관련 필드
    NSE_Inital_ROSC: "",
    NSE_24h: "",
    NSE_36h: "",
    NSE_48h: "",
    NSE_72h: "",

    // Pupil Section fields
    // CPR 중 (arrest)
    CPR_pupil: "",
    NPI_Rt_arrest: "",
    NPI_Lt_arrest: "",
    Size_Rt_arrest: "",
    Size_Lt_arrest: "",
    Min_Rt_arrest: "",
    Min_Lt_arrest: "",
    Ch_Rt_arrest: "",
    Ch_Lt_arrest: "",
    CV_Rt_arrest: "",
    CV_Lt_arrest: "",
    MCV_Rt_arrest: "",
    MCV_Lt_arrest: "",
    LAT_Rt_arrest: "",
    LAT_Lt_arrest: "",
    DV_Rt_arrest: "",
    DV_Lt_arrest: "",

    // ROSC 직후
    ROSC_pupil: "",
    NPI_Rt_ROSC: "",
    NPI_Lt_ROSC: "",
    Size_Rt_ROSC: "",
    Size_Lt_ROSC: "",
    Min_Rt_ROSC: "",
    Min_Lt_ROSC: "",
    Ch_Rt_ROSC: "",
    Ch_Lt_ROSC: "",
    CV_Rt_ROSC: "",
    CV_Lt_ROSC: "",
    MCV_Rt_ROSC: "",
    MCV_Lt_ROSC: "",
    LAT_Rt_ROSC: "",
    LAT_Lt_ROSC: "",
    DV_Rt_ROSC: "",
    DV_Lt_ROSC: "",

    // 12시간 후
    "12th_pupil": "",
    NPI_Rt_12hrs: "",
    NPI_Lt_12hrs: "",
    Size_Rt_12hrs: "",
    Size_Lt_12hrs: "",
    Min_Rt_12hrs: "",
    Min_Lt_12hrs: "",
    Ch_Rt_12hrs: "",
    Ch_Lt_12hrs: "",
    CV_Rt_12hrs: "",
    CV_Lt_12hrs: "",
    MCV_Rt_12hrs: "",
    MCV_Lt_12hrs: "",
    LAT_Rt_12hrs: "",
    LAT_Lt_12hrs: "",
    DV_Rt_12hrs: "",
    DV_Lt_12hrs: "",

    // 24시간 후
    "24th_pupil": "",
    NPI_Rt_24hrs: "",
    NPI_Lt_24hrs: "",
    Size_Rt_24hrs: "",
    Size_Lt_24hrs: "",
    Min_Rt_24hrs: "",
    Min_Lt_24hrs: "",
    Ch_Rt_24hrs: "",
    Ch_Lt_24hrs: "",
    CV_Rt_24hrs: "",
    CV_Lt_24hrs: "",
    MCV_Rt_24hrs: "",
    MCV_Lt_24hrs: "",
    LAT_Rt_24hrs: "",
    LAT_Lt_24hrs: "",
    DV_Rt_24hrs: "",
    DV_Lt_24hrs: "",

    // 36시간 후
    "36th_pupil": "",
    NPI_Rt_36hrs: "",
    NPI_Lt_36hrs: "",
    Size_Rt_36hrs: "",
    Size_Lt_36hrs: "",
    Min_Rt_36hrs: "",
    Min_Lt_36hrs: "",
    Ch_Rt_36hrs: "",
    Ch_Lt_36hrs: "",
    CV_Rt_36hrs: "",
    CV_Lt_36hrs: "",
    MCV_Rt_36hrs: "",
    MCV_Lt_36hrs: "",
    LAT_Rt_36hrs: "",
    LAT_Lt_36hrs: "",
    DV_Rt_36hrs: "",
    DV_Lt_36hrs: "",

    // 48시간 후
    "48th_pupil": "",
    NPI_Rt_48hrs: "",
    NPI_Lt_48hrs: "",
    Size_Rt_48hrs: "",
    Size_Lt_48hrs: "",
    Min_Rt_48hrs: "",
    Min_Lt_48hrs: "",
    Ch_Rt_48hrs: "",
    Ch_Lt_48hrs: "",
    CV_Rt_48hrs: "",
    CV_Lt_48hrs: "",
    MCV_Rt_48hrs: "",
    MCV_Lt_48hrs: "",
    LAT_Rt_48hrs: "",
    LAT_Lt_48hrs: "",
    DV_Rt_48hrs: "",
    DV_Lt_48hrs: "",

    // 60시간 후
    "60th_pupil": "",
    NPI_Rt_60hrs: "",
    NPI_Lt_60hrs: "",
    Size_Rt_60hrs: "",
    Size_Lt_60hrs: "",
    Min_Rt_60hrs: "",
    Min_Lt_60hrs: "",
    Ch_Rt_60hrs: "",
    Ch_Lt_60hrs: "",
    CV_Rt_60hrs: "",
    CV_Lt_60hrs: "",
    MCV_Rt_60hrs: "",
    MCV_Lt_60hrs: "",
    LAT_Rt_60hrs: "",
    LAT_Lt_60hrs: "",
    DV_Rt_60hrs: "",
    DV_Lt_60hrs: "",

    // 72시간 후
    "72th_pupil": "",
    NPI_Rt_72hrs: "",
    NPI_Lt_72hrs: "",
    Size_Rt_72hrs: "",
    Size_Lt_72hrs: "",
    Min_Rt_72hrs: "",
    Min_Lt_72hrs: "",
    Ch_Rt_72hrs: "",
    Ch_Lt_72hrs: "",
    CV_Rt_72hrs: "",
    CV_Lt_72hrs: "",
    MCV_Rt_72hrs: "",
    MCV_Lt_72hrs: "",
    LAT_Rt_72hrs: "",
    LAT_Lt_72hrs: "",
    DV_Rt_72hrs: "",
    DV_Lt_72hrs: "",
  });

  const fetchCaseData = async () => {
    try {
      setLoading(true);
      setDebugInfo({
        stage: "데이터 로드 시작",
        caseId,
        timestamp: new Date().toISOString(),
      });

      const response = await fetch(`${API_ENDPOINT}/cases/${caseId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      setDebugInfo((prev) => ({
        ...prev,
        stage: "API 응답 수신",
        responseStatus: response.status,
        responseHeaders: Object.fromEntries(response.headers.entries()),
      }));

      if (!response.ok) {
        throw new Error(`서버 응답 오류: ${response.status}`);
      }

      const result = await response.json();
      let parsedResponse = result;

      setDebugInfo((prev) => ({
        ...prev,
        stage: "응답 파싱 중",
        rawResponse: result,
      }));

      // body가 문자열인 경우 파싱
      if (typeof parsedResponse.body === "string") {
        try {
          parsedResponse = JSON.parse(parsedResponse.body);
        } catch (e) {
          console.error("body 파싱 실패:", e);
          throw new Error("서버 응답 형식이 올바르지 않습니다.");
        }
      }

      setDebugInfo((prev) => ({
        ...prev,
        stage: "데이터 처리 중",
        parsedResponse,
      }));

      if (parsedResponse.success) {
        // data가 배열인 경우 처리
        if (Array.isArray(parsedResponse.data)) {
          // caseId에 해당하는 데이터 찾기
          const caseData = parsedResponse.data.find(
            (item) => item.id === parseInt(caseId)
          );
          if (caseData) {
            setFormData(caseData.formData || {});
            setError(null);
            setDebugInfo((prev) => ({
              ...prev,
              stage: "데이터 로드 완료",
              formData: caseData.formData,
            }));
          } else {
            throw new Error(
              `ID ${caseId}에 해당하는 데이터를 찾을 수 없습니다.`
            );
          }
        } else {
          // 단일 객체인 경우 기존 로직 사용
          const formData =
            parsedResponse.data?.formData || parsedResponse.data || {};
          setFormData(formData);
          setError(null);
          setDebugInfo((prev) => ({
            ...prev,
            stage: "데이터 로드 완료",
            formData,
          }));
        }
      } else {
        throw new Error(
          parsedResponse.error || "데이터를 가져오는데 실패했습니다."
        );
      }
    } catch (error) {
      console.error("데이터 가져오기 오류:", error);
      setError(error.message);
      setDebugInfo((prev) => ({
        ...prev,
        stage: "오류 발생",
        error: error.message,
        stack: error.stack,
      }));
    } finally {
      setLoading(false);
    }
  };

  // 컴포넌트 마운트 시 데이터 로드
  useEffect(() => {
    fetchCaseData();
  }, [caseId]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const renderPageContent = () => {
    switch (currentPage) {
      case 1:
        return (
          <div className="page-content">
            <BasicInfoSection formData={formData} setFormData={setFormData} />
            <PreHospitalSection formData={formData} setFormData={setFormData} />
            <EMSTimeSection formData={formData} setFormData={setFormData} />
            <EMSCPRSection formData={formData} setFormData={setFormData} />
          </div>
        );
      case 2:
        return (
          <div className="page-content">
            <PatientArrivalSection
              formData={formData}
              setFormData={setFormData}
            />
            <UnderlyingDiseaseSection
              formData={formData}
              setFormData={setFormData}
            />
            <EmergencyRoomCPRSection
              formData={formData}
              setFormData={setFormData}
            />
            <EmergencyRoomResultSection
              formData={formData}
              setFormData={setFormData}
            />
          </div>
        );
      case 3:
        return (
          <div className="page-content">
            <AdmissionSection formData={formData} setFormData={setFormData} />
            <DischargeSection formData={formData} setFormData={setFormData} />
            <CPCSection formData={formData} setFormData={setFormData} />
          </div>
        );
      case 4:
        return (
          <div className="page-content">
            <NSESection formData={formData} setFormData={setFormData} />
            <PupilSection formData={formData} setFormData={setFormData} />
          </div>
        );
      default:
        return null;
    }
  };

  // CSV 생성 함수
  const generateCSV = () => {
    const headers = Object.keys(formData);
    const dataRow = headers.map((header) => {
      const value = formData[header] || "";
      return typeof value === "string" && value.includes(",")
        ? `"${value}"`
        : value;
    });

    return [headers.join(","), dataRow.join(",")].join("\n");
  };

  // 제출 핸들러 수정
  const handleSubmit = async () => {
    try {
      const requestData = {
        group_id: FIXED_GROUP_ID,
        template_id: 2,
        case_id: caseId,
        formData,
      };

      setDebugInfo({
        stage: "시작",
        data: requestData,
        group_id: FIXED_GROUP_ID,
      });

      const response = await fetch(`${API_ENDPOINT}/forms/${caseId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      if (!response.ok) {
        throw new Error(`서버 응답 오류: ${response.status}`);
      }

      const result = await response.json();
      let parsedResponse = result;

      if (typeof result === "string") {
        try {
          parsedResponse = JSON.parse(result);
        } catch (e) {
          console.error("응답 파싱 실패:", e);
          throw new Error("서버 응답 형식이 올바르지 않습니다.");
        }
      }

      if (parsedResponse.success) {
        setDebugInfo((prev) => ({
          ...prev,
          stage: "성공",
          result: parsedResponse,
        }));

        alert("데이터가 성공적으로 수정되었습니다!");
        window.location.reload();
      } else {
        throw new Error(parsedResponse.error || "데이터 수정에 실패했습니다.");
      }
    } catch (error) {
      console.error("예외 발생:", error);
      setDebugInfo((prev) => ({
        ...prev,
        stage: "예외 발생",
        error: error.message,
        stack: error.stack,
      }));
      alert(`수정에 실패했습니다!\n오류: ${error.message}`);
    }
  };

  // 로딩 및 에러 상태에 따른 UI 처리
  if (loading) {
    return (
      <div className="ohca-form-container">
        <MenuBar />
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <p>데이터를 불러오는 중...</p>
        </div>
        {/* 디버그 모니터링 창 추가 */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#f5f5f5",
            borderTop: "1px solid #ddd",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              padding: "5px 10px",
              backgroundColor: "#e0e0e0",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={() => setIsDebugVisible(!isDebugVisible)}
          >
            <span>디버그 모니터링</span>
            <span>{isDebugVisible ? "▼" : "▲"}</span>
          </div>
          {isDebugVisible && (
            <div
              style={{
                padding: "10px",
                maxHeight: "200px",
                overflow: "auto",
              }}
            >
              <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                {debugInfo
                  ? JSON.stringify(debugInfo, null, 2)
                  : "데이터 로드가 시작되면 결과가 여기에 표시됩니다."}
              </pre>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ohca-form-container">
        <MenuBar />
        <div style={{ textAlign: "center", marginTop: "100px" }}>
          <p>오류가 발생했습니다: {error}</p>
        </div>
        {/* 디버그 모니터링 창 추가 */}
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#f5f5f5",
            borderTop: "1px solid #ddd",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              padding: "5px 10px",
              backgroundColor: "#e0e0e0",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={() => setIsDebugVisible(!isDebugVisible)}
          >
            <span>디버그 모니터링</span>
            <span>{isDebugVisible ? "▼" : "▲"}</span>
          </div>
          {isDebugVisible && (
            <div
              style={{
                padding: "10px",
                maxHeight: "200px",
                overflow: "auto",
              }}
            >
              <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
                {debugInfo
                  ? JSON.stringify(debugInfo, null, 2)
                  : "오류 정보가 여기에 표시됩니다."}
              </pre>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="ohca-form-container">
      <MenuBar />
      <ProcessBar
        currentPage={currentPage}
        totalPages={totalPages}
        onPageClick={handlePageChange}
      />

      <div className="form-content">{renderPageContent()}</div>

      <div className="form-actions">
        <PageNavigation
          currentPage={currentPage}
          totalPages={totalPages}
          onPrevious={() => handlePageChange(currentPage - 1)}
          onNext={() => handlePageChange(currentPage + 1)}
          onSubmit={handleSubmit}
        />
      </div>

      {/* 디버그 모니터링 창 추가 */}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#f5f5f5",
          borderTop: "1px solid #ddd",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            padding: "5px 10px",
            backgroundColor: "#e0e0e0",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          onClick={() => setIsDebugVisible(!isDebugVisible)}
        >
          <span>디버그 모니터링</span>
          <span>{isDebugVisible ? "▼" : "▲"}</span>
        </div>
        {isDebugVisible && (
          <div
            style={{
              padding: "10px",
              maxHeight: "200px",
              overflow: "auto",
            }}
          >
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
              {debugInfo
                ? JSON.stringify(debugInfo, null, 2)
                : "데이터 로드가 시작되면 결과가 여기에 표시됩니다."}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default OHCAEditForm;
